import React, { useState, useEffect } from 'react';
import '../../App.css';
import logo from '../../assets/senai.svg';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Container, Box, TextField, Button, Typography, Grid,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from '@mui/material';
import axios from 'axios';


const Login = () => {
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState('');
    const [dialogMessage, setDialogMessage] = useState('');

    const navigate = useNavigate();

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    useEffect(() => { 
        localStorage.removeItem('authId');
    },[]);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            console.log(process.env.REACT_APP_BACKEND_URL);
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/login`, { email, senha });
            const  idUsuario  = response.data['usuario'];
            if (response.data.success) {
                localStorage.setItem('authId', idUsuario);
                navigate('/admin');
            } else {
                setDialogTitle('Erro');
                setDialogMessage('Email ou senha incorretos!');
                setDialogOpen(true);
            }
        } catch (error) {
            console.error('Erro ao fazer login', error);
            setDialogTitle('Erro');
            setDialogMessage('Erro ao fazer o login!');
            setDialogOpen(true);
        }
    };

    const handleCancel = () => {
        setEmail('');
        setSenha('');
        navigate('/');
    };


    return (
        <div>
            <div className="App">
                <div className="logo">
                    <img src={logo} alt="SENAI Logo" />
                </div>

                <navbar><Link className="nav-links" to="/">Home</Link></navbar>
            </div>
            <Container maxWidth="sm">
                <Box sx={{ my: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Login Administrativo
                    </Typography>
                    <form onSubmit={handleLogin}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    label="Email"
                                    variant="outlined"
                                    fullWidth
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Senha"
                                    type="password"
                                    variant="outlined"
                                    fullWidth
                                    value={senha}
                                    onChange={(e) => setSenha(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                >
                                    Confirmar
                                </Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button
                                    variant="outlined"
                                    color="secondary"
                                    fullWidth
                                    onClick={handleCancel}
                                >
                                    Cancelar
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                    <Dialog
                        open={dialogOpen}
                        onClose={handleDialogClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {dialogMessage}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDialogClose} color="primary" autoFocus>
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>

                </Box>
            </Container>
        </div>
    );
};

export default Login;
